module.exports = __webpack_public_path__ + "static/img/title-banner1-type1.048fadd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6/title-banner1-type1.png
// module id = 9KSa
// module chunks = 1